import { useEffect, useState } from "react";

const ZONES = [["LDN", "Europe/London"], ["NYC", "America/New_York"], ["TYO", "Asia/Tokyo"], ["UTC", "UTC"]];

const fmt = (tz) => new Date().toLocaleTimeString("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit" });

export const SessionClocks = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 15000);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="session-clocks" className="hidden lg:flex h-full items-center gap-4 border-l border-white/10 bg-black px-4 shrink-0 font-mono text-[10px] uppercase tracking-[0.18em]">
      {ZONES.map(([k, tz]) => (
        <span key={k} className="flex gap-1.5"><span className="text-white/35">{k}</span><span className="tabular-nums text-white/75">{fmt(tz)}</span></span>
      ))}
    </div>
  );
};
